import { FC } from 'react';

import { IconProps, LoadingIcon } from './Icon';
import { Stack } from './Stack';

/**
 * A reusable component that centers a loading icon within its parent using absolute positioning.
 *
 * @param size - The size of the loading icon.
 * @param className - Additional CSS classes to apply to the loading icon.
 *
 * @returns A centered loading indicator.
 */
export const LoadingIndicator: FC<Omit<IconProps, 'name'>> = ({
  size,
  className,
}) => (
  <Stack
    align="center"
    className="pointer-events-none absolute inset-0"
    justify="center"
    gap={2}
  >
    <LoadingIcon className={className} size={size} />
  </Stack>
);
